import { Component } from '@angular/core';
import { UserAdminDTO } from '../model/UserAdminDTO';
import { AdminService } from '../services/admin.service';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admin',
  standalone: true,
  imports: [NgFor, NgIf,CommonModule],
  templateUrl: './admin.component.html',
  styleUrl: './admin.component.css'
})
export class AdminComponent {

  users: UserAdminDTO[] = []; // Lista de usuarios
  errorMessage: string = ''; // Mensaje de error


  constructor(private adminService: AdminService, private router: Router) { } 

  ngOnInit(): void {
    this.fetchUsers(); 
}

fetchUsers(): void {
  this.adminService.getAllUsers().subscribe({
    next: (data: UserAdminDTO[]) => {
      this.users = data; // Asigna la lista de usuarios a la variable
    },
    error: (error: any) => {
      this.errorMessage = 'Error fetching users'; // Manejo de errores
      console.error(error); // Imprime el error en la consola
    }
  });
}

editUser(userId: string): void {
  this.router.navigate([`/admin/user/${userId}`]); // Navega a la página de edición del usuario

}
}
